export default __webpack_public_path__ + "static/media/media-peliput.fc0cebdd.jpg";